"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var StepLabel_1 = __importDefault(require("@mui/material/StepLabel"));
var component_2023_design_tokens_1 = require("@rentspree/component-2023-design-tokens");
var clsx_1 = require("clsx");
require("./step-label.scss");
var getDefaultLabelIconAndStyle = function (status, hasIcon) {
    var labelGap = (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.step-item.title-container.padding-bt-element');
    switch (status) {
        case 'complete':
            return {
                labelIcon: (0, jsx_runtime_1.jsx)(CheckCircleOutline_1.default, {}),
                stepLabelSx: {
                    gap: labelGap,
                },
            };
        case 'active':
        case 'inactive':
        default:
            return {
                labelIcon: (0, jsx_runtime_1.jsx)("div", {}),
                stepLabelSx: {
                    gap: hasIcon ? labelGap : 0,
                },
            };
    }
};
var StepLabel = function (_a) {
    var className = _a.className, status = _a.status, icon = _a.icon, subtitle = _a.subtitle, restProps = __rest(_a, ["className", "status", "icon", "subtitle"]);
    var stepLabelClassName = 'RSPStepLabel';
    var combinedClassName = (0, clsx_1.clsx)(className, stepLabelClassName);
    var _b = getDefaultLabelIconAndStyle(status, !!icon), stepLabelSx = _b.stepLabelSx, labelIcon = _b.labelIcon;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { children: [(0, jsx_runtime_1.jsx)(StepLabel_1.default, __assign({}, restProps, { className: "".concat(combinedClassName, "-").concat(status), sx: stepLabelSx, icon: icon || labelIcon })), subtitle && (0, jsx_runtime_1.jsx)(Box_1.default, { className: "".concat(combinedClassName, "-subtitle-").concat(status), children: subtitle })] }));
};
exports.StepLabel = StepLabel;
//# sourceMappingURL=step-label.js.map